import logo from "../../assest/logo.svg";
import leftBottom from "../../assest/about/ovals.svg";
import leftTop from "../../assest/popularEvents/lines1.svg";
import rightTop from "../../assest/right side top.svg";
import { Link } from "react-router-dom";
import mail from "../../assest/contact/email.png";
import location from "../../assest/contact/location.png";

const Footer = () => {
  return (
    <div className="footer">
      <img src={leftTop} alt="icon" className="Ltop-illu" />
      <img src={leftBottom} alt="icon" className="LBottom-illu" />
      <img src={rightTop} alt="icon" className="RTop-illu" />

      <div className="footer-content">
        <div className="footer-logo-section">
          <img src={logo} alt="logo" className="footer-logo" />
          <h3>AAYOJAN</h3>
          <p>
            United nation world health organize where they undertake specifical
            date to address global Righteous is that indignation and dislike men
            who are so beguiled…
          </p>
        </div>

        <div className="footer-newsletter">
          <h3>Newsletter</h3>
          <p>
            Subscribe our newsletter to get our latest update & news. Undertake
            specific mandates to the address global challenges the and a
            responsibilities.....
          </p>
          <div className="subscribe-container">
            <input
              type="email"
              placeholder="Email address"
              className="subscribe-input"
            />
            <button className="subscribe-button">Subscribe</button>
          </div>
        </div>

        <div className="footer-contactus">
          <h3>Contact Us</h3>
          <div>
            <img src={mail} alt="icon" />
            <p>info@event.com</p>
          </div>
          <div>
            <img src={location} alt="icon" />
            <p>30 commerce rode Alkapuri</p>
          </div>
          <Link to="/contact">
            <button className="contact-button">Contact Us</button>
          </Link>
        </div>
      </div>
      <div className="footer-copyright">
        <p>Copyright © 2024. All Rights Reserved</p>
      </div>
    </div>
  );
};

export default Footer;
